
import React from 'react';

interface ImageAutoSliderProps {
  images: string[];
  className?: string;
}

export const ImageAutoSlider = ({ images, className = "" }: ImageAutoSliderProps) => {
  // Duplicate images for seamless loop
  const duplicatedImages = [...images, ...images];

  return (
    <div className={`w-full overflow-hidden ${className}`}>
      {/* Scrolling images container with mask */}
      <div 
        className="w-full"
        style={{
          mask: 'linear-gradient(90deg, transparent 0%, black 10%, black 90%, transparent 100%)',
          WebkitMask: 'linear-gradient(90deg, transparent 0%, black 10%, black 90%, transparent 100%)'
        }}
      >
        <div className="flex gap-4 w-max animate-scroll-right">
          {duplicatedImages.map((image, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-80 h-60 rounded-xl overflow-hidden hover:scale-105 hover:brightness-110 transition-all duration-300 ease-out shadow-lg"
            >
              <img
                src={image}
                alt={`Visual Lab creation ${(index % images.length) + 1}`}
                className="w-full h-full object-cover"
                loading="lazy"
                width={320}
                height={240}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
